export default function CsharpVar() {
  return (
    <h2>Csharp Var</h2>
  );
}
